module.exports = __webpack_public_path__ + "static/media/aws-logo.8845b177.png";